<style scoped>
.team-image {
    width: 75px;
    height: 75px;
    display: block;
    margin: auto;
}
@media screen and (min-width: 450px) {
    .team-image {
        width: 100px;
        height: 100px;
    }
}
@media (max-width: 768px) {
    .center-part {
        max-width: calc(100vw - 180px);
    }
}
.v-card {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}
.team-name {
    margin-top: 8px;
}
.center-part, .d-flex > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>
<template>
    <v-card class="d-flex flex-row justify-space-between" @click="goToMatch()">
        <div v-if="homeTeam" class="team-section">
            <img v-if="homeTeam.id" :src="getTeamImageUrl(homeTeam.id)" class="team-image" />
            <div class="font-weight-bold team-name">{{ homeTeam.name }}</div>
        </div>

        <div class="flex-grow-1 d-flex flex-column justify-center center-part">
            <div class="font-weight-bold">{{ match.name }}</div>
            <div>
                <v-icon small>mdi-calendar</v-icon>
                {{ Date.formatFullLong(match.activity.startTime, !$vuetify.breakpoint.mobile).capitalize() }}
            </div>
            <div v-if="location">
                <v-icon small>mdi-map-marker</v-icon>
                {{ location }}
            </div>
        </div>
        <div v-if="awayTeam" class="team-section">
            <img v-if="awayTeam.id" :src="getTeamImageUrl(awayTeam.id)" class="team-image" />
            <div class="font-weight-bold team-name">{{ awayTeam.name }}</div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'zoezi-teamsport-referee-coming-match',

    props: ['match'],

    computed: {
        homeTeam() {
            return this.match?.teams[0];
        },
        awayTeam() {
            return this.match?.teams[1];
        },
        location() {
            if (!this.match) {
                return null;
            }
            let workout = this.match.activity;
            if (workout.location || workout.room) {
                return (workout.room ? workout.room.name : '') + (workout.location ? ', ' + workout.location.name : '');
            }
            return null;
        },
    },

    methods: {
        goToMatch() {
            const matchPage = this.$root.siteconfig?.pages?.match;
            this.$root.followLink(matchPage, this.match.id);
        },
        getTeamImageUrl(teamId) {
            return '/api/public/image/get?size=50x50&type=team&id=' + teamId;
        },
    }
}

</script>

<!-- FIXME: If more than one home or away team -->
